import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareClassicProformaIssueFormsDirectRoute: InvariantJiraRoute = {
	name: 'classic-software-proforma-issue-forms-direct',
	path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
	exact: true,
};
